// Soporte Candidatos
// SCRIPTS ACCORDIONS
$( '#heading01' ).click(function() {
  $('#icon-02, #icon-03, #icon-04').removeClass('icon-arrow-up')

  $('#icon-02, #icon-03, #icon-04').addClass('icon-arrow-down')

  if($("#collapse-01").hasClass('show')) {
    $('#icon-01').removeClass('icon-arrow-up')
    $('#icon-01').addClass('icon-arrow-down')
  } else{
    $('#icon-01').removeClass('icon-arrow-down')
    $('#icon-01').addClass('icon-arrow-up')
  }
})

$( '#heading02' ).click(function() {
  $('#icon-01, #icon-03, #icon-04').removeClass('icon-arrow-up')

  $('#icon-01, #icon-03, #icon-04').addClass('icon-arrow-down')

  if($("#collapse-02").hasClass('show')) {
    $('#icon-02').removeClass('icon-arrow-up')
    $('#icon-02').addClass('icon-arrow-down')
  } else{
    $('#icon-02').removeClass('icon-arrow-down')
    $('#icon-02').addClass('icon-arrow-up')
  }
})

$( '#heading03' ).click(function() {
  $('#icon-01, #icon-02, #icon-04').removeClass('icon-arrow-up')

  $('#icon-01, #icon-02, #icon-04').addClass('icon-arrow-down')

  if($("#collapse-03").hasClass('show')) {
    $('#icon-03').removeClass('icon-arrow-up')
    $('#icon-03').addClass('icon-arrow-down')
  } else{
    $('#icon-03').removeClass('icon-arrow-down')
    $('#icon-03').addClass('icon-arrow-up')
  }
})

$( '#heading04' ).click(function() {
  $('#icon-01, #icon-02, #icon-03').removeClass('icon-arrow-up')

  $('#icon-01, #icon-02, #icon-03').addClass('icon-arrow-down')

  if($("#collapse-04").hasClass('show')) {
    $('#icon-04').removeClass('icon-arrow-up')
    $('#icon-04').addClass('icon-arrow-down')
  } else{
    $('#icon-04').removeClass('icon-arrow-down')
    $('#icon-04').addClass('icon-arrow-up')
  }
})
